import React, { Component } from 'react'
import { observer } from 'mobx-react'
import TreeviewSelect from '../form/TreeviewSelect'

@observer
class ProductSelector extends Component {
    constructor(props) {
        super(props)
        const { DataExplorerStore } = this.props
        const { includedProducts } = DataExplorerStore

        this.state = {
            includedProducts,
        }

        this.wrapperRef = React.createRef()
        this.handleClickOutside = this.handleClickOutside.bind(this)
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside)
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside)
    }

    handleClickOutside(event) {
        const { DataExplorerStore } = this.props
        const { toggleProductSelector, changeIncludedProducts } = DataExplorerStore
        const { includedProducts } = this.state
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
            changeIncludedProducts(includedProducts)
            if (!event.target.closest('#productSelector')) toggleProductSelector()
        }
    }

    changeIncludedProducts = (selected) => {
        this.setState({ includedProducts: selected.value.map((p) => p.value) })
    }

    render() {
        const { DataExplorerStore } = this.props
        const {
            includedProducts, getProductSelectorData,
        } = DataExplorerStore
        return (
            <div ref={this.wrapperRef} className="productSelector">
                <div className="controls">
                    <div className="products">
                        <TreeviewSelect
                            cssClass="formControl"
                            label="products"
                            options={getProductSelectorData()}
                            returnAllSelectedNodes
                            name="productTree"
                            onChange={this.changeIncludedProducts}
                            numSelected={includedProducts.length}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default ProductSelector
